import { mergeClassNames } from "@/react/merge-class-names";
import { cn } from "@networx/utils/tailwind/cn";
import { Input as InputNextUI, InputProps } from "@nextui-org/input";

import CloseXIcon from "@/components/icons/CloseXIcon";
import CheckIcon from "@/components/icons/CheckIconV2";
import { useState } from "react";

export default function Input({
  preset,
  errorPreset,
  classNames,
  errorMessage,
  showIcon,
  value,
  formatter,
  isInvalid,
  ...props
}: Props) {
  preset ??= "none";
  errorPreset ??= "float";
  const [isFocus, setIsFocus] = useState(false);
  const classNamesMerged = mergeClassNames([
    // UNSET LAYER
    {
      input: "[border:none_!important] [box-shadow:none_!important] [padding-left:0_!important] [height:auto_!important] [padding:0_!important] [border-radius:0_!important]",
    },
    // DEFAULT LAYER
    {
      base: ["w-full", preset === "weird-center" && "w-36"],
      input: [
        "placeholder:text-[color:hsl(0,0%,65%)] placeholder:text-[15px] group-data-[invalid=true]:!text-black", preset === "weird-center" && "text-center focus:placeholder:text-primary focus:placeholder:font-bold",
      ],
      inputWrapper: [
        "bg-content1 py-6",
        "!border-small",
        "rounded-[6px]",
        isInvalid && "!border-danger",
      ],
    },
    // OVERRIDE LAYER
    classNames,
  ]);

  return (
    <div className={cn("relative flex flex-col gap-2 justify-center items-center", classNamesMerged?.base)}>
      <InputNextUI
        variant="bordered"
        color="primary"
        classNames={classNamesMerged}
        onFocusChange={setIsFocus}
        placeholder="Zip Code"
        value={!isFocus && formatter ? formatter(value) : value}
        aria-invalid={isInvalid}
        {...props}
      />
      {isInvalid && <div className={cn(
        errorPreset === "float" && "absolute -bottom-1 z-10 translate-y-full min-w-60",
        errorPreset === "float" && "before:content-[''] before:absolute before:-top-2 before:rotate-180 before:left-1/2 before:-translate-x-1/2 before:border-4 before:border-x-transparent before:border-b-transparent before:border-t-danger",
        errorPreset === "solid" && "w-full",
        "font-sans2 rounded-lg bg-danger px-4 py-1 text-[13px] sm:text-[16px] text-white",
        "text-center",
      )}>
        {errorMessage}
      </div>}
      {showIcon && <div className={cn(
        "flex justify-center items-center",
        "w-8 h-8",
        "rounded-full border border-default",
        "absolute -right-10 bg-content1"
      )}>
        {isInvalid && <CloseXIcon
          className="size-4"
          classNames={{ path: "stroke-default-500" }}
        />}
        {!isInvalid && <CheckIcon
          className="size-4"
          classNames={{ path: "stroke-default-500" }}
        />}
      </div>}
    </div>
  );
}



interface Props extends Omit<InputProps, "errorMessage"> {
  errorMessage?: string;
  preset?: "weird-center" | "none";
  errorPreset?: "float" | "solid";
  showIcon?: boolean;
  formatter?: (value: InputProps['value']) => string;
}
